import styled from 'styled-components';

export const CustomAmenitiesSection = styled.section`
  margin-top: 40px;
`;
